import { Outlet, useNavigate } from "react-router-dom";

export default function CommonMain(props) {
  return (
    <>
      <Outlet />
    </>
  );
}
